import clsx from "clsx"

import determineOverdueBucket from "@utils/determineOverdueBucket"
import { faIcon } from "@utils/faIcon"

import Icon from "@atoms/Icon/Icon"

import { objectColorByStatus } from "@constants/colorByStatus"

import styles from "./StatusDot.module.scss"
import { StatusDotProps } from "./StatusDot.types"

export default function StatusDot(props: StatusDotProps) {
    const { status, size, isOutstandingOrOverdue, dateDue } = props

    const overloadedStatus =
        isOutstandingOrOverdue && dateDue
            ? `overdue ${determineOverdueBucket(dateDue)?.toLowerCase().replaceAll("_", " ")}`
            : status

    return (
        <div
            className={clsx(styles.base, styles[`${size}Size`])}
            style={
                {
                    "--status-color": objectColorByStatus[overloadedStatus as keyof typeof objectColorByStatus],
                } as React.CSSProperties
            }
        >
            <Icon
                icon={faIcon({ name: "circle-small", style: "solid" })}
                size={size === "sm" ? 8 : 10}
                container="fixedHeight"
            />
        </div>
    )
}
